import React from 'react';
import { Box } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import ContactSection from '../components/ContactSection.jsx';
import Footer from '../components/Footer.jsx';

const ContactPage = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        <ContactSection />
      </Box>
      <Footer />
    </Box>
  );
};

export default ContactPage;
